//state
export var adsState = {
    ads: [],
    ads_creatives:[],
    status_ads: ""
  };
  
  //getters
  export var adsGetters = {
    //funciones para optener informacion del state
    getAds: state => state.ads,
    getAdsCreatives: state => state.ads_creatives
  };
  //actions
  export var adsActions = {
    async getAds({ commit }) {
      commit("ads_request");
      await this._vm.$http
        .get("/apache/rest_api/apache.ad", {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
            fields:
              '["id","name", "ad_id", "status", "state", ("adset_id",["id","name"]), "is_imported"]'
          }
        })
        .then(res => {
          var ads = res.data;
          commit("ads_success", ads);
          return res;
        })
        .catch(err => {
          commit("ads_error");
          return err;
        });
    },
    async newAd({ commit, state }, ad) {
      commit("page_request");
      var formData = new FormData();
      let title_ids = `[`;
      title_ids += `(0,0,{ 'name': '${ad.title}', 'text': '${ad.title}', 'ad_id': False, 'active': False}),`
      title_ids = title_ids.slice(0, -1) + ']';
      let body_ids = `[`;
      body_ids += `(0,0,{ 'name': '${ad.content}', 'text': '${ad.content }', 'ad_id': False, 'active': False}),`
      body_ids = body_ids.slice(0, -1) + ']';
      let description_ids = `[`;
      description_ids += `(0,0,{ 'name': '${ad.description}', 'text': '${ad.description}', 'ad_id': False, 'active': False}),`
      description_ids = description_ids.slice(0, -1) + ']';
      let creative_ids = `[`;
      creative_ids += `(6,0,[${ad.creative_ids[0]}]),`
      creative_ids = creative_ids.slice(0, -1) + ']';
      var new_ad = `{
        'name':'${ad.name}',
        'ad_type_id':${ad.type.id},
        'adset_id': ${ad.adset_id.id},
        'title_ids':${title_ids},
        'body_ids': ${body_ids},
        'description_ids':${description_ids},
        'call_to_action_id':${ad.callToAction.id},
        'creative_ids':${creative_ids},
        'display_url': '${ad.display_url}',
        'is_political_ad': ${ad.is_political_ad?'True':'False'},
        'status': '${ad.status.value}'
      }`;
      formData.append("data", new_ad);
      await this._vm.$http
        .post("/apache/rest_api/apache.ad", formData, {
          headers: {
          //  "X-Odoo-dbfilter": "apachev1",
          }
        })
        .then(res => {
          if (res.status == 201) {
            ad.id = res.data.id;
            var ads = state.ads;
            ad.account_status = ad.account_status.value
            ads.push(ad);
            commit("ads_success", ads);
            return ads;
          } else {
            commit("ads_error");
          }
        })
        .catch(err => {
          commit("ads_error");
          return err;
        });
    },
    async editAd({ commit, state }, ad) {
      commit("page_request");
      var {
        id,
        name,
        account_id,
        account_status
      } = ad;
      var formData = new FormData();
      var new_ad = `{
        'name':'${name}',
        'account_id':'${account_id}',
        'account_status': ${account_status.value},
        }`;
      formData.append("data", new_ad);
      await this._vm.$http
        .put("/apache/rest_api/apache.ad", formData, {
          headers: {
          //  "X-Odoo-dbfilter": "apachev1",
          },
          params: {
            ids: `[${id}]`
          }
        })
        .then(res => {
          if (res.status == 200) {
            //adsAccount.id = res.data.id;
            var ads = state.ads;
            var index;
            for (var i = 0; i < ads.length; i++) {
              if (ads[i].id == id) {
                index = i;
                ads[i] = ad;
                break;
              }
            }
            ads.splice(index, 1);
            ads.splice(index, 0, ad);
            commit("ads_success", ads);
            return adsAccounts;
          } else {
            commit("ads_error");
          }
        })
        .catch(err => {
          commit("ads_error");
          return err;
        });
    },
    async deleteAd({ commit, state }, id) {
      commit("ads_request");
      await this._vm.$http
      .delete(`/apache/rest_api/apache.ad/${id}`, { 
        headers: {
        //"X-Odoo-dbfilter": "apachev1"
        }
    })
        .then(res => {
          if (res.status == 210) {
            var ads = state.ads
            commit("ads_success", ads);
            return ads;
          } else {
            commit("ads_error");
          }
        })
        .catch(err => {
          commit("ads_error");
          return err;
        });
    },
    async deleteAdUtility({ commit, state }, id) {
      commit("ads_request");
      var index;
      var ads = state.ads;
      for (var i = 0; i < ads.length; i++) {
        if (ads[i].id == id) {
          index = i;
          break;
        }
      }
      commit("ads_delete_success", index);
      return ads;
    },
    async getAdsCreatives({ commit }) {
      commit("ads_request");
      await this._vm.$http
        .get("/apache/rest_api/apache.ad.creative", {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
            fields:
              '["id","name", "state", "create_date"]'
          }
        })
        .then(res => {
          var ads_creatives = res.data;
          commit("ads_creatives_success", ads_creatives);
          return res;
        })
        .catch(err => {
          commit("ads_error");
          return err;
        });
    },
    async newAdCreatives({commit, state}, ad){
      let formData = new FormData();
      let new_ad = `{
        'account_id':'${ad.account_id.id}',
        'creative_file':'${ad.files.file}',
        'creative_file_h':'${ad.files.file_h}',
        'creative_file_v':'${ad.files.file_v}',
        'creative_file_video_thumbnail':'${ad.files.file_video_thumbnail}',
        'creative_file_video_thumbnail_h':'${ad.files.file_video_thumbnail_h}',
        'creative_file_video_thumbnail_v':'${ad.files.file_video_thumbnail_v}',
        'creative_filename':'${ad.files.file_name}',
        'creative_video_thumbnail_filename':'${ad.files.video_name}',
        'description':'${ad.description}',
        'name':'${ad.name}',
        'resource_type':'${ad.resource_type.value}',
        'link_data': '${ad.link_data}'
      }`;
      formData.append("data", new_ad);
      await this._vm.$http
        .post("/apache/rest_api/apache.ad.creative", formData, {
          headers: {
          //  "X-Odoo-dbfilter": "apachev1",
          }
        })
        .then(res => {
          if (res.status == 201) {
            let ads_creatives = state.ads_creatives;
            ad.id = res.data.id;
            ads_creatives.push(ad);
            commit("ads_creatives_success", ads_creatives);
            return ads;
          } else {
            commit("ads_error");
          }
        })
        .catch(err => {
          commit("ads_error");
          return err;
        });
    }   
  };
  
  //mutations
  
  export var adsMutations = {
    ads_request(state) {
      state.status_ads = "loading";
    },
    ads_success(state, payload) {
      state.status_ads = "success";
      state.ads = payload;
    },
    ads_delete_success(state,payload) {
      state.status_ads = "success";
      state.ads.splice(payload,1)
    },
    ads_creatives_success(state,payload){
      state.status_ads = "success";
      state.ads_creatives = payload;
    },
    ads_error(state) {
      state.status_ads = "error";
    }
  };
  